import { FaNodeJs } from "react-icons/fa6";

export default function Logo() {
  return (
    <div className="flex items-center justify-center gap-1 font-bold text-3xl">
      <FaNodeJs />
      <h3>Ali</h3>
    </div>
  );
}
